import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { Typography } from "@mui/material";

import messages from "../../../assets/locale/messages";
import {
  fillTemplate,
  formatAmount,
  getSubscriptionPlanName,
} from "../../Events/Form/Steps/ChooseCrewSize/crewSizeUtils";
import { formatSubscriptionDate } from "./subscriptionPlanUtils";

import "./Subscription.scss";

/** The company's current plan: name, yearly price, crew fee rates and billing year dates. */
const SubscriptionPlanCard = ({ subscription }) => {
  const lang = useSelector((state) => state.locale.lang);
  const t = messages[lang].companiesList.subscription;
  const plan = subscription.subscription_plan;

  const details = [
    fillTemplate(t.dailyRate, { rate: formatAmount(plan.daily_rate) }),
    fillTemplate(t.extendedRate, { rate: formatAmount(plan.extended_rate) }),
    fillTemplate(t.startDate, {
      date: formatSubscriptionDate(subscription.start_date, lang),
    }),
    fillTemplate(t.renews, {
      date: formatSubscriptionDate(subscription.renewal_date, lang),
    }),
  ];

  return (
    <div className="subscription-plan-card">
      <div className="subscription-plan-card__plan">
        <Typography component="h2" className="text-heading-sm subscription-plan-card__name">
          {getSubscriptionPlanName(plan, lang)}
        </Typography>
        <Typography component="p" className="text-body-sm subscription-plan-card__price">
          {fillTemplate(t.yearlyPrice, { price: formatAmount(plan.price_per_year) })}
        </Typography>
      </div>
      <ul className="subscription-plan-card__details">
        {details.map((detail) => (
          <li key={detail} className="text-label-sm">
            {detail}
          </li>
        ))}
      </ul>
    </div>
  );
};

SubscriptionPlanCard.propTypes = {
  /** `{ subscription_plan, start_date, renewal_date }` of the company. */
  subscription: PropTypes.shape({
    subscription_plan: PropTypes.shape({
      name_en: PropTypes.string,
      name_ar: PropTypes.string,
      price_per_year: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      daily_rate: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      extended_rate: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    }).isRequired,
    start_date: PropTypes.string,
    renewal_date: PropTypes.string,
  }).isRequired,
};

export default SubscriptionPlanCard;
